import React from 'react';
import { Popover } from 'antd';
import { PopoverContent } from '../MapPortalMap';
import { TooltipPlacement } from 'antd/es/tooltip';
import './FeaturePopover.scss';
import DOMPurify from 'dompurify';

interface FeaturePopoverProps {
  visible: boolean;
  content: PopoverContent;
  onClose: () => void;
  containerId: string;
  popupTitle: string;
  defaultPosition: TooltipPlacement;
  popupTitleUnit: string;
  popupCustomStyle: string;
  pixelPos: { x: number; y: number };
}

const FeaturePopover: React.FC<FeaturePopoverProps> = ({
  visible,
  content,
  onClose,
  containerId,
  popupTitle,
  defaultPosition,
  popupTitleUnit,
  popupCustomStyle,
}) => {
  const titleValue =
    popupTitleUnit && content?.[popupTitleUnit] ? `${popupTitle ? popupTitle + ' ' : ''}${content[popupTitleUnit]}` : popupTitle || 'Feature Details';

  const getProcessedHTML = () => {
    if (!popupCustomStyle) return '';
    let html = popupCustomStyle;

    html = html.replace(/\[title\]/g, titleValue || '');

    Object.entries(content ?? {}).forEach(([key, value]) => {
      html = html.replace(new RegExp(`\\[${key}\\]`, 'g'), String(value ?? ''));
    });

    return html;
  };

  const processedHTML = getProcessedHTML();

  return (
    <div className="popover-wrapper">
      <Popover
        key={defaultPosition}
        trigger="click"
        open={visible}
        // onOpenChange={onClose}
        getPopupContainer={() => document.getElementById(containerId) as HTMLElement}
        content={
          <div className="popover__container">
            <button onClick={onClose} className="popover__close-button">
              ×
            </button>
            {popupCustomStyle ? (
              <div className="custom-popup-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(processedHTML) }} />
            ) : (
              <>
                <h4 className="popover__title">{titleValue}</h4>
                {(content?.photos || content?.picture) && <img src={content?.photos || content?.picture} alt="Feature" className="popover__image" />}
                {content?.video && <div className="popover__video" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.video) }} />}
                {content?.attachment && (
                  <div className="popover__attachment">
                    <img src={content.attachment} alt="Attachment" className="popover__image" />
                  </div>
                )}
                {Object.entries(content ?? {})
                  .filter(([key]) => !['photos', 'picture', 'video', 'attachment'].includes(key))
                  .map(([key, value]) => (
                    <div key={key} className="popover__info">
                      <strong>{key}: </strong>
                      {String(value)}
                    </div>
                  ))}
              </>
            )}
          </div>
        }
      />
    </div>
  );
};

export default FeaturePopover;
